import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "h6"
}
const _hoisted_4 = {
  key: 1,
  class: "p-small no-margin"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" This is me! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSlider = _resolveComponent("AppSlider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Pick your style!",
    description: "Swipe left or right to browse your options. Choose the style that best fits you.",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.QuizService.close())),
    "is-vertically-aligned": true
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, { onClick: _ctx.navigateNext }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AppSlider, {
        class: "quiz-slider",
        sliderData: _ctx.QUIZ_CONTRIBUTION_PRESETS,
        spaceBetween: 70,
        pagination: { 'clickable': true },
        scrollbar: false,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
        onSlideChange: _ctx.setActiveIndex,
        onAfterInit: _ctx.setDefaultSlide
      }, {
        default: _withCtx((props) => [
          _createElementVNode("div", _hoisted_1, [
            (props.slide.imageId)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.QUIZ_CONTRIBUTION_STYLE_PICTURES.find((p) => p.id === props.slide.imageId).src,
                  alt: `Slide ${props.index + 1}`
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          (props.slide.title)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.slide.title), 1))
            : _createCommentVNode("", true),
          (props.slide.text)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.slide.text), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["sliderData", "navigation", "onSlideChange", "onAfterInit"])
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back"]))
}